
import { useEffect } from 'react';

export default function Testimonials() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://reputationhub.site/reputation/assets/review-widget.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-white to-gray-50 overflow-hidden" id="temoignages">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <iframe
          className="lc_reviews_widget"
          src="https://reputationhub.site/reputation/widgets/review_widget/COnx2ltix5Ue2wCthqYv"
          frameBorder="0"
          scrolling="no"
          style={{ minWidth: '100%', width: '100%' }}
          title="Avis clients"
        />
      </div>
    </section>
  );
}
